"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Message = void 0;
var Message = /*#__PURE__*/function (Message) {
  Message["AudioFrame"] = "AUDIO_FRAME";
  Message["SpeechStart"] = "SPEECH_START";
  Message["VADMisfire"] = "VAD_MISFIRE";
  Message["SpeechEnd"] = "SPEECH_END";
  Message["SpeechStop"] = "SPEECH_STOP";
  return Message;
}(Message || (exports.Message = Message = {}));

